import React from 'react'
import flash from '@/shared/assets/flashImage.webp'
import wave from '@/shared/assets/TDWave.webp'
import cls from './DistributionBlock.module.scss'

export const DisitributionBlock = () => {
    return (
        <saection className={cls.DisitributionBlock}>
            <article className={cls.container}>
                <div className={cls.text}>
                    <h3>Revolutionary Blockchain Spin Key</h3>
                    <p>
                        Our patented innovation brings offline blockchain technology to spin tracking and management.
                        Acting as a secure licensing key, it stores and distributes spins with unmatched precision and
                        reliability, ensuring seamless operations and complete control without an internet connection.
                    </p>
                </div>
                <img
                    src={flash}
                    alt="flash"
                />
            </article>
            <img
                className={cls.wave}
                src={wave}
                alt="wave"
            />
        </saection>
    )
}
